import React from 'react';
import { PhoneIcon, ShieldCheckIcon } from 'lucide-react';
import { PHONE_DISPLAY, PHONE_TEL } from './shared';
// 01 — REASSURANCE BAR · [Conversion] [Trust]
// No urgency, no ticker, no countdown. Calm, static reassurance on a dark band.
export function AnnouncementBar() {
  return <div className="w-full bg-forest-700 text-paper" data-id="element-22">
      <div className="mx-auto flex w-full max-w-6xl flex-col items-center justify-center gap-1.5 px-5 py-2.5 text-center sm:flex-row sm:gap-4 sm:px-6 lg:px-8" data-id="element-23">
        <span className="inline-flex items-center gap-2 text-small" data-id="element-24">
          <ShieldCheckIcon aria-hidden="true" className="h-4 w-4 text-gold" strokeWidth={1.75} data-id="element-25" />
          Free, confidential initial discussion · No obligation
        </span>
        <span aria-hidden="true" className="hidden text-paper/30 sm:inline" data-id="element-26">
          ·
        </span>
        <a href={PHONE_TEL} className="inline-flex items-center gap-2 rounded-btn px-1 text-small font-semibold text-paper underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-27">
          <PhoneIcon aria-hidden="true" className="h-4 w-4" strokeWidth={1.75} data-id="element-28" />
          Call {PHONE_DISPLAY}
        </a>
      </div>
    </div>;
}